v
<script>
import TaxReturnTableRow from "@/components/accountants/tax_return/table/TaxReturnTableRow.vue";
import TaxReturnTable from "@/components/accountants/tax_return/table/TaxReturnTable.vue";
import TaxReturnTableHeader from "@/components/accountants/tax_return/table/TaxReturnTableHeader.vue";
import TaxReturnTableInput from "@/components/accountants/tax_return/table/TaxReturnTableInput.vue";

export default {
  name: "TaxReturnStarterDeductionSection",
  components: {TaxReturnTableInput, TaxReturnTableHeader, TaxReturnTable, TaxReturnTableRow},
  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>

<template>
  <TaxReturnTable>
    <template v-slot:header>
      <tr>
        <th>
          <translate>Beschrijving</translate>
        </th>

        <th>
          <translate>Waarde</translate>
        </th>
      </tr>
    </template>

    <template v-slot:body>
      <tr>
        <td scope="row">
          Hebt u recht op startersaftrek?
        </td>

        <td>
          <input type="checkbox"
                 v-model="data.right_starter_deduction"/>
        </td>
      </tr>

      <tr>
        <td scope="row">
          Hebt u in de periode {{ data.year - 5 }} tot en met {{ data.year - 1 }} minimaal 1 keer startersaftrek bij
          arbeidsongeschiktheid gehad?
        </td>

        <td>
          <input type="checkbox"
                 v-model="data.received_starter_deduction_past_5_years"/>
        </td>
      </tr>

      <tr>
        <td scope="row">
          Hoe vaak kreeg u in die periode startersaftrek bij arbeidsongeschiktheid?
        </td>

        <td>
          <TaxReturnTableInput v-model="data.times_starter_deduction_received_last_5_years"
                               :resettable="false"
                               type="number"/>
        </td>
      </tr>
    </template>
  </TaxReturnTable>
</template>

<style scoped lang="scss">

</style>
